document.addEventListener('DOMContentLoaded', () => {
  const agree = document.getElementById('agree');
  if (!agree) return;

  const CHECKOUT_SEL = [
    '[name="checkout"]',      
    '[name="goto_pp"]',       
    '[name="goto_gc"]',       
    'a[href*="/checkout"]',   
  ].join(',');

  // 1) Block any direct checkout clicks
  document.body.addEventListener('click', e => {
    const btn = e.target.closest(CHECKOUT_SEL);
    if (!btn) return;
    if (!agree.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      alert(Shopify.translations.cartAcceptTerms);
    }
  }, { capture: true });

  // 2) Fallback: only on Cart page, only for the real checkout form
  if (window.location.pathname === '/cart') {
    const checkoutForm = document.querySelector('form[action="/cart"]');
    checkoutForm?.addEventListener('submit', e => {
      // ensure it's the checkout button
      if (e.submitter?.name === 'checkout' && !agree.checked) {
        e.preventDefault();
        alert(Shopify.translations.cartAcceptTerms);
      }
    }, { capture: true });
  }
});
